import React from 'react'
import { Link } from 'react-router-dom'
import {Grid, Row, Col} from 'react-flexbox-grid'
import Img from 'gatsby-image'
import Facebook from 'mdi-material-ui/Facebook'
import Twitter from 'mdi-material-ui/Twitter'
import Youtube from 'mdi-material-ui/Youtube'
import Linkedin from 'mdi-material-ui/Linkedin'
import NavigationLinks from './navigationLinks';
import Hidden from '@material-ui/core/Hidden';



export default class Footer extends React.Component {
    // TODO debug maxWidth hotfix
    render(){
	var imgs = this.props.imgs;
	return (
	    <div className="section dark">
	    <Grid id="footer">
		<Row>
			<Hidden xsDown>
		    <Col xs={6}>
			<div style={{textAlign: 'right'}}>
				<Link to="/">
				    <Img style={{width: "250px"}} sizes={imgs.logo.white.childImageSharp.sizes} />
				</Link>
				</div>
			</Col>
			<Col xs={6}>
			<div style={{textAlign: "right"}}>
			    <p style={{fontFamily: "Nunito", fontSize: "25px", fontWeight: "bold", paddingRight: "15px"}}>Get in touch<br />&mdash;<br /></p>
			    <Link to="mailto:nucleus@sharemeals.org"
				  className="hover">
				nucleus@sharemeals.org
			    </Link>
			    <br />
			    <a href="https://www.facebook.com/sharemealsnyu"
				  target="_blank"
				  className="hover">
				<Facebook style={{height: 24, width: 24, fill: "rgb(245, 245, 245)"}}/>
			    </a>
			    <a href="https://twitter.com/ShareMeals"
				  target="_blank"
				  className="hover">
				<Twitter style={{height: 24, width: 24, fill: "rgb(245, 245, 245)"}}/>
			    </a>
			    <a href="https://www.youtube.com/channel/UCmQy2_ILRftC8n8yWj4rpAg"
				  target="_blank"
				  className="hover">
				<Youtube style={{height: 24, width: 24, fill: "rgb(245, 245, 245)"}}/>
			    </a>
			    <a href="https://www.linkedin.com/company/share-meals/"
				  target="_blank"
				  className="hover">
				<Linkedin style={{height: 24, width: 24, fill: "rgb(245, 245, 245)"}}/>
			    </a>
			</div>
		    </Col>
		    </Hidden>

		    <Hidden smUp>
			<Col xs={12}>
			<div style={{textAlign: "center", paddingTop: "2rem", paddingBottom: "2rem"}}>
			    <p style={{fontFamily: "Nunito", fontSize: "25px", fontWeight: "bold"}}>Get in touch<br />&mdash;<br /></p>
			    <Link to="mailto:nucleus@sharemeals.org"
				  className="hover">
				nucleus@sharemeals.org
			    </Link>
			    <br />
			    <a href="https://www.facebook.com/sharemealsnyu"
				  target="_blank"
				  className="hover">
				<Facebook style={{height: 24, width: 24, fill: "rgb(245, 245, 245)"}}/>
			    </a>
			    <a href="https://twitter.com/ShareMeals"
				  target="_blank"
				  className="hover">
				<Twitter />
			    </a>
			    <a href="https://www.youtube.com/channel/UCmQy2_ILRftC8n8yWj4rpAg"
				  target="_blank"
				  className="hover">
				<Youtube />
			    </a>
			    <a href="https://www.linkedin.com/company/share-meals/"
				  target="_blank"
				  className="hover">
				<Linkedin />
			    </a>
			</div>
		    </Col>
		    </Hidden>
		</Row>
		<Row>
			<NavigationLinks style={{textAlign: 'left', opacity: "0.5", display: 'block'}}/>
		</Row>
	    </Grid>
	    </div>
	)
    }
}



// WEBPACK FOOTER //
// ./src/components/footer.jsx